"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DateSync = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17,18 L17,19 L15.7523273,19.0017356 C16.4082878,19.6744598 17.1524205,20 18,20 C19.195018,20 20.0888661,19.4370288 20.7374527,18.2588697 C20.8706253,18.0169613 21.1746885,17.9288135 21.4165969,18.0619861 C21.6585053,18.1951587 21.746653,18.499222 21.6134804,18.7411303 C20.7940445,20.2296378 19.5709148,21 18,21 C16.8520803,21 15.8466329,20.5460477 15.0002321,19.661628 L15,21 L14,21 L14,18 L17,18 Z M8,4 L8,5 L16,5 L16,4 L17,4 L17,5 L19,5 C19.5522847,5 20,5.44771525 20,6 L20,11 L19,11 L19,10 L5,10 L5,19 L12,19 L12,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,6 C4,5.44771525 4.44771525,5 5,5 L7,5 L7,4 L8,4 Z M22,13 L22,16 L19,16 L19,15 L20.2351525,15.0000675 C19.6247698,14.3258908 18.8869135,14 18,14 C16.8524564,14 15.952528,14.5665399 15.2539951,15.7535834 C15.1139448,15.9915761 14.8074805,16.0709742 14.5694877,15.930924 C14.331495,15.7908737 14.2520969,15.4844093 14.3921472,15.2464166 C15.2628528,13.7667935 16.4808769,13 18,13 C19.1925341,13 20.2001985,13.4599382 20.9999622,14.3559174 L21,13 L22,13 Z M7,6 L5,6 L5,9 L19,9 L19,6 L17,6 L17,7 L16,7 L16,6 L8,6 L8,7 L7,7 L7,6 Z" })));
};
DateSync.displayName = 'DateSync';
exports.default = DateSync;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DateSync.js.map